import { render, staticRenderFns } from "./PriorityServiceSet.vue?vue&type=template&id=e07faf20&"
import script from "./PriorityServiceSet.vue?vue&type=script&lang=js&"
export * from "./PriorityServiceSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PriorityServiceSet.vue"
export default component.exports